<template lang="html">
  <fullscreen-overlay-layout @close="closeOverlay" :title="getCurrentRT.title">
    <div
      style="padding: 20px;"
      :class="{ 'hidden-record': submission.is_hidden }"
    >
      <submission-card-header
        :showHeaderOptions="false"
        :submission="submission"
      />
      <submission-response-text
        :submission="submission"
        :shortenText="true"
        :smallFont="true"
      />
      <div class="start-xs">
        <span class="i" style="font-size: 12px; color: #273248;">
          {{ getPromptWordsLength }} Words
        </span>
      </div>
      <div id="overlay-comment-list" class="ml-auto mt3 tr pb4">
        <comment-card-list
          class="br3 shadow-1"
          :submissionID="submissionID"
          :listOfComments="filteredCommentsToShow"
        />
        <pl-button
          v-if="commentsToShow.length > 1"
          @click.native="toggleShowComments"
          class="italics pl-primary-secondary pl-small"
        >
          {{ show_all_comments ? 'collapse comments' : 'see more comments' }}
        </pl-button>
      </div>
    </div>
  </fullscreen-overlay-layout>
</template>
<script>
  import { mapGetters } from 'vuex';
  import SubmissionCardHeader from './submissionCard/cardHeader';
  import SubmissionResponseText from './submissionResponseText';
  import CommentCardList from './commentCardList';
  import FullscreenOverlayLayout from 'components/fullscreenOverlay';
  import wordCountService from '../services/wordCount/wordCount';

  export default {
    data() {
      return {
        show_all_comments: false,
      };
    },
    components: {
      SubmissionCardHeader,
      SubmissionResponseText,
      CommentCardList,
      FullscreenOverlayLayout,
    },
    computed: {
      ...mapGetters(['getCurrentRT']),
      topLevelCommentID() {
        return this.$route.query.topLevelCommentID;
      },
      submissionID() {
        return this.$route.query.submissionID;
      },
      commentsToShow() {
        return this.submission.comments || [];
      },
      filteredCommentsToShow() {
        return this.show_all_comments
          ? this.commentsToShow
          : this.commentsToShow.filter(
              (comment) => comment.id === this.topLevelCommentID
            );
      },
      getPromptWordsLength() {
        return wordCountService.getWordCount(this.submission);
      },
    },
    props: {
      submission: {
        type: Object,
        default() {
          return {
            flagged_by: [],
            user: {
              name: null,
              avatar_url: null,
            },
            start_date: null,
          };
        },
      },
    },
    methods: {
      toggleShowComments() {
        this.show_all_comments = !this.show_all_comments;
        setTimeout(() => {
          document.getElementById('overlay-comment-list').scrollIntoView({
            block: 'start',
            inline: 'nearest',
            behavior: 'smooth',
          });
        });
      },
      closeOverlay() {
        this.$router.replace({ query: null });

        this.$emit('close');
      },
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// individualCommentOverlay.vue?2752f00c